// @ts-check

/**
 * Bento Workflows (Matrix) — one-shot scroll-into-view reveal.
 *
 * The matrix frame stays put; its contents opacity/blur in on a diagonal
 * wavefront (top→bottom, left→right) the first time the matrix scrolls into
 * view. Each cell gets a `--sweep` index (grid row + column); the timing and
 * easing live in CSS. Reduced-motion or missing IntersectionObserver leaves
 * the matrix fully visible, no motion.
 *
 * (The Matrix mock table in the workflows tile is sized/scrolled via CSS —
 * no shrink-to-fit here.)
 */

(function() {
    'use strict';

    const matrices = /** @type {HTMLElement[]} */ (Array.from(
        document.querySelectorAll('.bento__matrix'),
    ));
    if (!matrices.length) {
        return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    for (let m = 0; m < matrices.length; m++) {
        const matrix = matrices[m];

        const chrome = /** @type {HTMLElement|null} */ (
            matrix.querySelector('.bento__matrix-chrome'));
        if (chrome) {
            chrome.style.setProperty('--sweep', '0');
        }

        const head = matrix.querySelector('.bento__matrix-head');
        if (head) {
            for (let c = 0; c < head.children.length; c++) {
                /** @type {HTMLElement} */ (head.children[c])
                    .style.setProperty('--sweep', String(c));
            }
        }

        const rows = matrix.querySelectorAll('.bento__matrix-row');
        for (let r = 0; r < rows.length; r++) {
            const cells = rows[r].children;
            for (let c = 0; c < cells.length; c++) {
                /** @type {HTMLElement} */ (cells[c])
                    .style.setProperty('--sweep', String(r + 1 + c));
            }
        }

        matrix.classList.add('is-armed');
    }

    if (typeof IntersectionObserver === 'undefined') {
        for (let m = 0; m < matrices.length; m++) {
            matrices[m].classList.add('is-revealed');
        }
        return;
    }

    const io = new IntersectionObserver((entries, obs) => {
        for (let i = 0; i < entries.length; i++) {
            const entry = entries[i];
            if (entry.isIntersecting) {
                entry.target.classList.add('is-revealed');
                obs.unobserve(entry.target);
            }
        }
    }, {threshold: 0.2});

    for (let m = 0; m < matrices.length; m++) {
        io.observe(matrices[m]);
    }
})();
